import React, { Suspense } from 'react';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIconMui from '@mui/icons-material/Close';
import Toolbar from '@mui/material/Toolbar';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { Preloader } from '#component/preloader';
import ShipmentList from '#component/dashboard/shipment-list';
import { DialogAppBar, CloseIcon } from '#component/dashboard/styles';

const Transition = React.forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />);

export const CardDialog = props => {
  const {
    tab,
    data,
    open,
    loading,
    account,
    isMobile,
    handleClose,
    identifiersMap,
    isMapDialogOpened,
    handleOpenMapDialog
  } = props;

  const identifier = identifiersMap[tab];

  return (
    <Dialog
      TransitionComponent={Transition}
      onClose={handleClose}
      open={open}
      fullScreen
      className="cluster"
    >
      <DialogAppBar>
        <Toolbar>
          <CloseIcon
            as={IconButton}
            aria-label="close"
            color="inherit"
            edge="start"
            onClick={handleClose}
          >
            <CloseIconMui />
          </CloseIcon>
          <Typography variant="h5">
            {identifier}
          </Typography>
        </Toolbar>
      </DialogAppBar>
      {identifiersMap[tab] && !loading ? (
        <Suspense fallback={<Preloader />}>
          <ShipmentList
            tab={tab}
            data={data[tab]}
            account={account}
            isMobile={isMobile}
            identifiersMap={identifiersMap}
            isMapDialogOpened={isMapDialogOpened}
            handleOpenMapDialog={handleOpenMapDialog}
          />
        </Suspense>
      ) : (
        <Preloader />
      )}
    </Dialog>

  );
};
